import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'

const Templates = () => {
    const table = useRef(null)
    const urlGetData = '/v0/templates'
    const localStorageOrderKey = 'tblTemplatesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'filename' },
        { data: 'usage_count' }
    ]

    const tableHead = (
        <tr>
            <th>Template</th>
            <th>Document Types</th>
        </tr>
    )
    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/templates/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Templates</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/templates/new" className="btn btn-mr btn-primary" type="button">New Template</Link>
                                <Link to="/cadm/std_documents">Portfolio Document Types</Link>
                                <Link to="/cadm/report_schemes">Report Schemes</Link>
                                <Link to="/cadm/qms_document_types">QMS Document Types</Link>
                                <Link to="/cadm/qa_document_types">QA Document Types</Link>
                                <Link to="/cadm/qa_record_types">QA Record Types</Link>
                                <Link to="/cadm/template_placeholders">SMART Template Placeholders</Link>
                            </div>
                            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Templates</strong> may be assigned to one or many <strong>document types</strong>. <br/>
                                Templates can be used for <strong>portfolio (project and product)</strong> documents, records and reports; and <strong>quality (QMS and QA)</strong> documents and records. <br/>
                                (Each type can only have one template, so adding a type to a template will automatically remove that type from any other template.)
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Templates
